import { router } from "@inertiajs/react";

type MarkAsDreamJobParams = {
  dreamJobPath: string;
  invalidateQuery?: () => void;
  afterSuccess?: () => void;
};

export const markAsDreamJob = ({
  dreamJobPath,
  invalidateQuery,
  afterSuccess,
}: MarkAsDreamJobParams) => {
  router.post(
    dreamJobPath,
    {},
    {
      preserveScroll: true,
      onSuccess: () => {
        invalidateQuery && invalidateQuery();

        router.reload({ only: ["applications", "can_choose_dream_job"] });

        afterSuccess && afterSuccess();
      },
    },
  );
};
